export default {
  title: 'Home',
  bodyClasses: '',
  sections: [
    {
      id: 'hero-main',
      type: 'hero',
      grid: null,
      options: {
        classes: 'n7-hero-main',
        background: true
      }
    },
    {
      id: 'content-main',
      type: 'hero',
      grid: null,
      options: {
        classes: 'n7-hero-works',
        background: true
      }
    },
    {
      id: 'collection-hero',
      type: 'collection',
      grid: 3,
      options: {
        classes: 'is-overlay overlay_bottom',
        itemPreview: {
          limit: null,
          striptags: false
        }
      }
    },
    {
      id: 'collection-badge',
      type: 'collection',
      grid: 2,
      options: {
        classes: ' ',
        itemPreview: {
          limit: null,
          striptags: false
        }
      }
    },
    {
      id: 'collection-stats',
      type: 'collection',
      grid: 1,
      options: {
        classes: 'is-overlay collection_left',
        itemPreview: {
          limit: null,
          striptags: false
        }
      }
    },
    {
      id: 'collection-news',
      type: 'collection',
      grid: 1,
      options: {
        classes: 'collection_right',
        itemPreview: {
          limit: 200,
          striptags: true
        }
      }
    },
    {
      id: 'collection-credits',
      type: 'collection',
      grid: 10,
      options: {
        classes: 'collection-credits'
      }
    },
    // {
    //   id: 'collection-cycles',
    //   type: 'collection',
    //   grid: 4,
    //   options: {
    //     classes: 'is-vertical'
    //   }
    // },
    // {
    //   id: 'hero-2',
    //   type: 'hero',
    //   grid: null,
    //   options: {
    //     classes: 'n7-hero-works',
    //     background: false
    //   }
    // },

  ]
};
